/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material'
import React from 'react'
import { riskLayoutContentWrapperStyle } from './RiskLayout.style'
import RiskNavbar from './RiskNavBar'

type RiskLayoutProps = { children?: React.ReactNode }

export const RiskLayout = ({ children }: RiskLayoutProps) => {
  return (
    <Box>
      <RiskNavbar />
      <Box css={riskLayoutContentWrapperStyle}>{children}</Box>
    </Box>
  )
}

export default RiskLayout
